import { render, staticRenderFns } from "./ProductModifiers.vue?vue&type=template&id=25101132&"
import script from "./ProductModifiers.vue?vue&type=script&lang=js&"
export * from "./ProductModifiers.vue?vue&type=script&lang=js&"
import style0 from "./ProductModifiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports